import * as Reducers from './video.reducers';

export const VideoReducers = {
  Reducers,
};
